import { fetchApi } from "../fetchApi";

export async function accountingApi({
  method = "get_income_this_year",
  model = "account.move",
  args = [false],
}) {
  const raw = JSON.stringify({
    jsonrpc: "2.0",
    method: "call",
    params: {
      args,
      model,
      method,
      kwargs: {},
    },
  });
  const requestOptions = {
    method: "POST",
    body: raw,
    redirect: "follow",
  };
  return fetchApi({
    requestOptions,
    endpoint: `/web/dataset/call_kw/${model}/${method}`,
  });
}
